import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  paymentTagSchema,
  paymentTagListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/paymentTags/actions';
import { PaymentTagsActionTypes as types } from 'app/ducks/paymentTags/types';

function* createPaymentTagSaga(action): any {
  yield put(sagaActions.createPaymentTagPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).paymentTags.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, paymentTagSchema);

    yield put(sagaActions.createPaymentTagSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createPaymentTagFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updatePaymentTagSaga(action): any {
  yield put(sagaActions.updatePaymentTagPending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).paymentTags.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, paymentTagSchema);

    yield put(sagaActions.updatePaymentTagSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updatePaymentTagFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getPaymentTagSaga(action): any {
  yield put(sagaActions.getPaymentTagPending());

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).paymentTags.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, paymentTagSchema);
    yield put(sagaActions.getPaymentTagSuccess(normalizedResponse));
    return normalizedResponse.entities.paymentTags[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getPaymentTagFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllPaymentTagsSaga(action): any {
  yield put(
    sagaActions.getAllPaymentTagsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());
  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.paymentTags.pagination),
    )
    : action.payload.pagination;
  const [error, response] = yield (yield TeammoApi(yield select())).paymentTags.list(
    action.payload.organisationId,
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(
      response,
      paymentTagListSchema,
    );

    yield put(
      sagaActions.getAllPaymentTagsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllPaymentTagsFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createPaymentTagSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_PAYMENT_TAG_REQUESTED,
    createPaymentTagSaga,
  );
}

function* updatePaymentTagSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_PAYMENT_TAG_REQUESTED,
    updatePaymentTagSaga,
  );
}

function* getPaymentTagSagaWatcher(): any {
  yield takeLatest(
    types.GET_PAYMENT_TAG_REQUESTED,
    getPaymentTagSaga,
  );
}

function* getAllPaymentTagsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_PAYMENT_TAGS_REQUESTED,
    getAllPaymentTagsSaga,
  );
}

export default function* root(): any {
  yield all([
    createPaymentTagSagaWatcher(),
    updatePaymentTagSagaWatcher(),
    getPaymentTagSagaWatcher(),
    getAllPaymentTagsSagaWatcher(),
  ]);
}
